export default "__VITE_ASSET__Cbxu5_SN__"